export const HOSPITALITY_COMPANY_TYPES = [
  { value: "Restaurant", label: "Restaurant" },
  { value: "Home Chef", label: "Home Chef" },
  { value: "Cafe", label: "Cafe" },
  { value: "Fast Food", label: "Fast Food" },
  { value: "Bakery", label: "Bakery" },
  { value: "Cloud Kitchen", label: "Cloud Kitchen" },
  { value: "Bar & Lounge", label: "Bar & Lounge" },
  { value: "Catering", label: "Catering" },
];

export const isHospitalityIndustry = (industryType) =>
  (industryType || "").toLowerCase() === "hospitality";
